const scrollPositions = new Map();

export function saveScroll(key) {
  scrollPositions.set(key, window.scrollY);
}

export function restoreScroll(key) {
  const y = scrollPositions.get(key);
  if (typeof y === "number")
    requestAnimationFrame(() => window.scrollTo(0, y));
}
